export default {
	NORMAL: 'NORMAL',
	INITIAL: 'INITIAL',
	FINAL: 'FINAL'
};
